// eslint-disable-next-line
import React from "react";
import { Link } from "react-router-dom";


const BusinessLink = ({ to = "", children, ...props }) => {

  // let { slugname } = useParams();
  const pathName = window.location.pathname
  // const replacedString = pathName.replace(`${slugname}/`, '')
  // const replacedString = pathName.replace(`/`, '')
  return (
    <>
      {/* <Link {...props} to={`/${slugname}${to}`} className={replacedString === to ? 'active' : ''}> */}
      {/* <Link {...props} to={`${to}`} className={pathName === `/${to}` ? 'active' : ''}> */}
      {pathName === to && (
        <>
          <Link {...props} to={`${to}`} className='active'>
            {children}
          </Link >
        </>
      )}
      {pathName !== to && (
        <>
          <Link {...props} to={`${to}`} className=''>
            {children}
          </Link >
        </>
      )}
    </>
  )
}

export default BusinessLink